module.exports = __webpack_public_path__ + "static/media/defrag_1.eb928ff5.ico";